// extracted by mini-css-extract-plugin
module.exports = {"durationHeader":"RequestList-module_durationHeader__12z8gFCeA-eudaj74IpZl_","sqlTimingsHeader":"RequestList-module_sqlTimingsHeader__3aV3hZZ0EANcSJG7u_cM0l"};